import { apiEndPoint } from "./endPoint";

interface SubscriptionData {
  userId: string;
  subscription: any;
}

export const putPushSubscriptionData = async (
  subscriptionData: SubscriptionData,
  token: string
) => {
  const url = `${apiEndPoint}/putPushSubscriptionData`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(subscriptionData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
